import React from "react";
import { Link } from "react-router-dom";
import ReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import AccountBalanceOutlined from "@mui/icons-material/AccountBalanceOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import MenuBookOutlined from "@mui/icons-material/MenuBookOutlined";
import ForumOutlined from "@mui/icons-material/ForumOutlined";
import PeopleOutline from "@mui/icons-material/PeopleOutline";
import services from "../../data/services";
import "./Services.css";

const serviceIcons = {
  "/LÖPANDE-BOKFÖRING": MenuBookOutlined,
  "/BOKSLUT": AccountBalanceOutlined,
  "/MOMSDEKLARATION": ReceiptLongOutlined,
  "/INKOMSTDEKLARATION": DescriptionOutlined,
  "/RÅDGIVNING": ForumOutlined,
  "/LÖNEADMINISTRATION": PeopleOutline,
  "/ÅRSREDOVISNING": DescriptionOutlined,
};
const Services = () => (
  <section className="site-services" aria-labelledby="services-heading">
    <div className="site-container">
      <div className="site-section-heading">
        <div><p className="site-eyebrow">Våra tjänster</p><h2 id="services-heading">Vi hjälper dig med helheten.</h2></div>
        <p>Från den första verifikationen till årets bokslut. Välj den hjälp ditt företag behöver.</p>
      </div>
      <div className="site-service-grid">
        {services.map(({ path, title, description }, index) => {
          const Icon = serviceIcons[path];
          return (
          <Link className="site-service-card" to={path} key={path} aria-label={`${title} – Läs mer`}>
            <div className="site-service-card-top"><Icon aria-hidden="true" /><span>0{index + 1}</span></div>
            <h3>{title}</h3><p>{description}</p>
            <span className="site-service-cta">Läs mer <span aria-hidden="true">↗</span></span>
          </Link>
          );
        })}
      </div>
    </div>
  </section>
);
export default Services;
